import { HomeComponentMessage, LanguageConstants } from './../../shared-components/constant';
import { Component, OnInit } from '@angular/core';
import { EngagementService } from '../../services/engagement.service';
import { EngagementModel } from '../../models/engagement.model';
import { Sharedservice } from './../../shared-components/shared.service';
import { MessageService } from 'primeng/api';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { InfraService } from 'src/app/services/infra.service';
import { Observable, Subscription } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AppConfigurationService } from '../../services/appConfiguration.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  activeEngagements: EngagementModel[];
  private loggedInId: number;
  public isPrivacyPolicyAgreed = false;
  templateId: number;
  countryId: number;
  isEngagementCreationEnabled: boolean= false;
  isEngagementReadOnly: boolean = false;
  private regionName: string;
  public version: string = environment.version;
  public loadspinner = false;
  private userDataSubscription: Subscription;
  private ConfigData: any;
  welcomeMessage = '';
  isProjectExist = false;
  langCode: string;
  currLangTranslation: any;
  url: any;

  constructor(private infraService: InfraService, private userService: UserService,
    private engagementService: EngagementService, public sharedService: Sharedservice,
    private messageService: MessageService, private translateService: TranslateService,
    private appConfigService: AppConfigurationService) {
    this.infraService.infraDetails$.subscribe(data => {
      this.templateId = data.TemplateId;
      this.countryId = data.CountryId;
      this.regionName = data.RegionName;
      this.url = data.WebEndPoint2;
    });  

    this.isEngagementReadOnly = this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.isEngagementCreationEnabled = this.appConfigService.GetConfigValueByKey("IsProjectEnabled");
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    setTimeout(() => {
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.welcomeMessage = this.currLangTranslation.home.welcomeToDatabookGreeting;
  }, 1000);
    this.loadspinner = true;
    this.messageService.clear();
    
    this.userDataSubscription = this.userService.cast.subscribe((userData: UserModel) => {
      if (userData && userData.Id !== undefined) {
        this.loggedInId = userData.Id;
        this.isPrivacyPolicyAgreed = userData.IsPrivacyPolicyAgreed;
        if (!this.isPrivacyPolicyAgreed) {
          this.loadspinner = false;
        }
        this.engagementService.getMyActiveEngagements(this.regionName).subscribe((data: EngagementModel[]) => {
          this.loadspinner = false;
          this.activeEngagements = data;
          if (this.activeEngagements !== undefined && this.activeEngagements.length > 0) {
            this.isProjectExist = true;
          }
        }, error => {
        });
      }
      this.appConfigService.initialConfigLoading().subscribe(data => {
        this.appConfigService.appConfigurationSubject.next(data);
        this.isEngagementCreationEnabled = this.appConfigService.GetConfigValueByKey("IsProjectEnabled");
      });

    });
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      this.welcomeMessage = this.currLangTranslation.home.welcomeToDatabookGreeting;
    });
  }
    

  ngOnDestroy() {
    this.userDataSubscription.unsubscribe();
  }
}
